import styled, { css } from 'styled-components'
import { COLORS } from '@styles/colors'
import { DEVICES } from '@constants/global'
import { textSM } from '@styles/fonts'

export const CheckboxLabel = styled.span`
  position: relative;
  display: block;
  padding-left: 35px;
  color: ${COLORS.secondary};

  &:before {
    content: '';
    background-color: transparent;
    border: 1px solid ${COLORS.secondary};
    border-radius: 4px;
    padding: 8px;
    display: inline-block;
    position: absolute;
    left: 0;
    vertical-align: middle;
    cursor: pointer;
    top: 50%;
    transform: translateY(-50%);
  }

  @media ${DEVICES.mobile} {
    ${textSM};
  }
`

export const CheckboxWrap = styled.div`
  display: inline-block;
`

export const Checkbox = styled.label`
  display: inline-block;
  cursor: pointer;

  input {
    padding: 0;
    height: initial;
    width: initial;
    margin-bottom: 0;
    display: none;
    cursor: pointer;
  }

  input:checked + ${CheckboxLabel}:after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    margin-top: -8px;
    left: 6px;
    width: 6px;
    height: 12px;
    border: solid ${COLORS.secondary};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  ${props =>
    props.error &&
    css`
      input + ${CheckboxLabel}::before {
        border-color: ${COLORS.primary} !important;
      }
      
      ${CheckboxLabel} {
        span{
          color: ${COLORS.primary} !important;
          a {
            color: ${COLORS.primary} !important;
          }
        }
      }
    `}
`
